import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import _ from "lodash";
import PageLoader from "../../../../../../components/PageLoader";
import {reconciliationData} from '../reconciliation-request-items'

import { updateNestedValue } from "../../../../../../common/services/common.service";
import { reconciliationRequestItems } from "../../../../../../redux/settlement-hub/reconciliation-request-items/action";
import { selectReconciliationRequestItemCreatedItem, selectReconciliationRequestItemDeletedItem, selectReconciliationRequestItemsListItems, selectReconciliationRequestItemUpdatedItem } from "../../../../../../redux/settlement-hub/reconciliation-request-items/selector";
import { ReconciliationRequestItemPopup } from "../components/reconciliation-request-item-popup.component";
import { libraryData, TO_BE_INITIATED } from "../../constants/constants";

const ReconciliationRequestItems = ({
  selectedReconciliationRequest
}: any) => {

  const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [showReconciliationRequestItemPopup, setShowReconciliationRequestItemPopup] = useState<boolean>(false);
  const [selectedReconciliationRequestItem, setSelectedReconciliationRequestItem] = useState<any>({
    "Id": 0,
    "ReconciliationRequestId": 0,
    "SettlementRefNo": "",
    "PaymentId": 0,
    "ReconciliationRequestStatusId": TO_BE_INITIATED,
    "Amount": {
        "Currency": "INR",
        "Value": "0"
    },
    "Comission": {
        "Currency": "INR",
        "Value": "0"
    },
    "WithholdingAmount": {
        "Currency": "INR",
        "Value": "0"
    },
    "TCS": {
        "Currency": "INR",
        "Value": "0"
    },
    "TDS": {
        "Currency": "INR",
        "Value": "0"
    },
    "Remarks": ""
});  

  const [listItems, setListItems] = useState<any>([]);
  const listOfReconciliationRequestItemsData = useSelector(selectReconciliationRequestItemsListItems)
  const createReconciliationRequestItemsData = useSelector(selectReconciliationRequestItemCreatedItem)
  const editReconciliationRequestItemsData = useSelector(selectReconciliationRequestItemUpdatedItem)
  const deleteReconciliationsItemData = useSelector(selectReconciliationRequestItemDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'SettlementRefNo', headerName: 'Settlement Ref No', sortable: true, filter: true, filterType: 'text', },
      { field: 'PaymentId', headerName: 'Payment Id', sortable: true, filter: true, filterType: 'text', },
      { field: 'Amount.Value', headerName: 'Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'Comission.Value', headerName: 'Comission', sortable: true, filter: true, filterType: 'number', },
      { field: 'WithholdingAmount.Value', headerName: 'Withholding Amount', sortable: true, filter: true, filterType: 'number', },
      { field: 'TCS.Value', headerName: 'TCS', sortable: true, filter: true, filterType: 'number', },
      { field: 'TDS.Value', headerName: 'TDS', sortable: true, filter: true, filterType: 'number', },
      { field: 'ReconciliationRequestItemStatusId', headerName: 'Status', sortable: true, filter: true, filterType: 'text', cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData, menuKey: 'Value', menuValue: 'Description', callback: handleStatus, anchorPosition: 'top-left' },
      },

      {field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},
      {field: 'UpdatedOnUtc', headerName: 'Updated On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date',},

    ]);
  }

  
  const handleStatus = () => {

  }

  const handleInnerFormChange: any = ({path, value}: any) => {
    console.log('selectedReconciliationRequestItem, path, value', selectedReconciliationRequestItem, path, value)
    const updatedData = updateNestedValue(selectedReconciliationRequestItem, path, value)

    console.log('updatedData', updatedData)
    setSelectedReconciliationRequestItem({...updatedData});
  }

  const handleAdd = () => {   
    setSelectedReconciliationRequestItem({
      "Id": 0,
      "ReconciliationRequestId": 0,
      "SettlementRefNo": "",
      "PaymentId": 0,
      "ReconciliationRequestStatusId": TO_BE_INITIATED,
      "Amount": {
          "Currency": "INR",
          "Value": "0"
      },
      "Comission": {
          "Currency": "INR",
          "Value": "0"
      },
      "WithholdingAmount": {
          "Currency": "INR",
          "Value": "0"
      },
      "TCS": {
          "Currency": "INR",
          "Value": "0"
      },
      "TDS": {
          "Currency": "INR",
          "Value": "0"
      },
      "Remarks": ""
  })
    setShowReconciliationRequestItemPopup(true)
  }

  const handleEdit = (data: any) => {
    setSelectedReconciliationRequestItem({
      "settlement_ref_no": data.settlement_ref_no,
      "payment_id": data.payment_id,
      "status":  data.status,
      "amount":  data.amount.value,
      "comission":  data.comission.value,
      "withholding_amount":  data.withholding_amount.value,
      "tcs":  data.tcs.value,
      "tds":  data.tds.value,
      })
    setShowReconciliationRequestItemPopup(true)
  }

  const handleDelete = async (data: any) => {
    console.log('delete item', data)
    await dispatch(reconciliationRequestItems.delete({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-request-items/delete`,
      entity: 'reconciliationRequestItems',
      jsonData: {
        Context:{},
        Records: [{Id: data?.ReconciliationRequest?.Id}]
      }
    }));
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Reconciliation Item</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Initiate Reconciliation',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    listReconciliationRequestItems();
  }

  const listReconciliationRequestItems = async () => {
    console.log('reconciliationRequestItems')
    await dispatch(reconciliationRequestItems.resetAction({actionType:'list'}))
    await dispatch(reconciliationRequestItems.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-request-items/list`,
      entity: 'reconciliationRequestItems',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSaveReconciliationRequestItem = async (selectedReconciliationRequestItem: any) => {
    console.log('selectedReconciliationRequestItem', selectedReconciliationRequestItem)
    if (selectedReconciliationRequestItem?.Id > 0) {      
      await dispatch(reconciliationRequestItems.resetAction({actionType:'update'}))
      await dispatch(reconciliationRequestItems.update({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-request-items`, entity: 'reconciliationRequestItems', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationRequestItem
              }]
            }
          ]
        }
      }))
    } else {
      await dispatch(reconciliationRequestItems.resetAction({actionType:'update'}))
      await dispatch(reconciliationRequestItems.create({
        url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/settlement-hub/reconciliation-request-items`, entity: 'reconciliationRequestItems', jsonData: {
          Records: [
            {
              Context: {},
              Records: [{
                ...selectedReconciliationRequestItem
              }]
            }
          ]
        }
      }))
    }
    closeModal();
    listReconciliationRequestItems();
  }

  const closeModal = () => {
    setShowReconciliationRequestItemPopup(false)
  }

  useEffect(() => {
    console.log('listOfReconciliationRequestItemsData', listOfReconciliationRequestItemsData)
    // if(listOfReconciliationRequestItemsData?.isSuccess){
      if(listOfReconciliationRequestItemsData?.result?.items && listOfReconciliationRequestItemsData?.result?.items?.length > 0)
      {
        console.log('listOfReconciliationRequestItemsData?.result?.items[0].Error', listOfReconciliationRequestItemsData?.result?.items[0].Error)
        if (listOfReconciliationRequestItemsData?.result?.items[0].Error){
          setListItems(reconciliationData)          
        }   
        else {
          setListItems(listOfReconciliationRequestItemsData?.result?.items)
        }     
      }  else {
        console.log('reconciliationData', reconciliationData)
        setListItems(reconciliationData)
      }    
    // }
  }, [listOfReconciliationRequestItemsData]);

  useEffect(() => {
    console.log('list items', listItems)
  
  }, [listItems]);

  useEffect(() => {
    listReconciliationRequestItems();
  }, [deleteReconciliationsItemData]);

  useEffect(() => {
    createColumnDefs()
    listReconciliationRequestItems()
  }, [pageData, pageSize])

  return (
    <>
      {
        showReconciliationRequestItemPopup ?
          <ReconciliationRequestItemPopup
            selectedReconciliationRequestItem={selectedReconciliationRequestItem}
            closeModal={closeModal}
            handleSaveReconciliationRequestItem={handleSaveReconciliationRequestItem}
            handleInnerFormChange={handleInnerFormChange}
          /> : <></>
      }

      {listOfReconciliationRequestItemsData?.isLoading || 
      createReconciliationRequestItemsData?.isLoading || 
      editReconciliationRequestItemsData?.isLoading || 
      deleteReconciliationsItemData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          enableFilter={true}
          rowData={listItems}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={listOfReconciliationRequestItemsData?.result?.pagination}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}   
          headingName="Reconciliation Request Items" />
      }
    </>
  );
};

export default ReconciliationRequestItems;


